import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'mainView', 'switchView']

  connect() {
    this.resetBound = this.reset.bind(this)
    this.dropdown = this.element.closest('.dropdown, .dropend')
    // Bootstrap fires this when the dropdown closes — return to the main view.
    if (this.dropdown) this.dropdown.addEventListener('hidden.bs.dropdown', this.resetBound)
  }

  disconnect() {
    if (this.dropdown) this.dropdown.removeEventListener('hidden.bs.dropdown', this.resetBound)
  }

  showSwitch() {
    this.mainViewTarget.hidden = true
    this.switchViewTarget.hidden = false
  }

  reset() {
    if (this.hasMainViewTarget) this.mainViewTarget.hidden = false
    if (this.hasSwitchViewTarget) this.switchViewTarget.hidden = true
  }

  search() {
    clearTimeout(this.timeout)

    // submit the search form with a debounce timeout of 500 ms
    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, 500)
  }
}
